import React, { useState, Fragment } from "react";
import styled from "styled-components";
import Tooltip from "@mui/material/Tooltip";
import { FaInfoCircle } from "react-icons/fa";
import { Grid } from "@mui/material";

const MainWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: 5px;
  position: relative;
`;

const InfoIconWrapper = styled.div`
  color: #707070;
  opacity: ${({ isHover }) => (isHover ? 1 : 0.5)};
  padding-top: 3px;
`;

const Item = styled.div`
  padding: 3px;
`;

export default function InfoToolTip({
  adminLevelNames,
  countries,
  left = 4,
  right = 7,
  arrowTop
}) {
  const [showToolTip, setShowToolTip] = useState(false);

  return (
    <Fragment>
      <MainWrapper>
        <Tooltip
          open={showToolTip}
          onClose={() => {
            setShowToolTip(false);
          }}
          onOpen={() => {
            setShowToolTip(true);
          }}
          title={
            <Grid container justifyContent="left">
              <Grid item xs={left} justifyContent={"center"}>
                {adminLevelNames.map((item) => {
                  return <Item>{item}</Item>;
                })}
              </Grid>
              <Grid item xs={1} justifyContent={"center"}>
                {adminLevelNames.map((item) => {
                  return <Item>{"-"}</Item>;
                })}
              </Grid>
              <Grid item xs={right} justifyContent={"center"}>
                {countries.map((item) => {
                  return <Item>{item}</Item>;
                })}
              </Grid>
            </Grid>
          }
          arrow
          placement="right-start"
          PopperProps={{
            sx: {
              "& .MuiTooltip-tooltipArrow": {
                width: "290px",
                border: "1px solid #7070701f",
                color: "#707070",
                textAlign: "left",
                padding: "5px",
                position: "absolute",
                zIndex: "2",
                background: "#ffffff 0% 0% no-repeat padding-box",
                boxShadow: "0px 3px 6px #00000029",
                borderRadius: "4px",
                opacity: "1",
                wordWrap: "break-word",
                font: "normal normal 500 13px/18px Open Sans",
              },
              "& .MuiTooltip-arrow": {
                top: arrowTop,
                "&::before": {
                  backgroundColor: "white",
                  border: "1px solid #7070701f",
                  marginBottom: "50px",
                },
              },
              "& .MuiTooltip-tooltip": {
                marginLeft: "4px !important",
              },
            },
          }}
        >
          <InfoIconWrapper isHover={showToolTip}>
            <FaInfoCircle />
          </InfoIconWrapper>
        </Tooltip>
      </MainWrapper>
    </Fragment>
  );
}
